import React from 'react'
import { InvoiceIssuesMain } from './components/InvoiceIssuesMain'
import { InvoiceIssuesProvider } from './context/InvoiceIssuesProvider'

export const InvoiceIssues = () => {
  return (
    <InvoiceIssuesProvider>
      <InvoiceIssuesMain />
    </InvoiceIssuesProvider>
  )
}
